var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.progress.percentage < 100 && !_vm.isOnboardingAlreadyCompleted
    ? _c(
        "div",
        { staticClass: "dynamic-dashboard-checklist" },
        [
          _c(
            "div",
            {
              staticClass: "minimized-checklist-card",
              class: { visible: _vm.minimized, hidden: !_vm.minimized },
              on: {
                click: function($event) {
                  return _vm.$emit("minimized-clicked")
                }
              }
            },
            [
              _c("div", { staticClass: "minimized-content" }, [
                _c("span", { staticClass: "minimized-title" }, [
                  _vm._v("Store setup")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "minimized-progress" }, [
                  _vm._v(
                    _vm._s(_vm.progress.completed) +
                      "/" +
                      _vm._s(_vm.progress.total)
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "AppAccordionItem",
            {
              staticClass:
                "overflow-visible dynamic-dashboard-checklist-accordion",
              class: { visible: !_vm.minimized, hidden: _vm.minimized },
              attrs: {
                name: "dynamic-dashboard-checklist",
                title: "Store setup",
                visible: true,
                progress: _vm.progress
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "subtitle",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "checklist-header-progress-bar" },
                          [
                            _c("div", {
                              staticClass: "checklist-header-progress-bar-fill",
                              style: { width: _vm.progress.percentage + "%" }
                            })
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1389690406
              )
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "steps-container" },
                [
                  _vm._l(_vm.steps, function(step, index) {
                    return [
                      _c(
                        "div",
                        {
                          key: index,
                          class: { completed: _vm.isStepCompleted(index) },
                          attrs: { "data-step-number": index + 1 }
                        },
                        [
                          _c("ChecklistStep", {
                            attrs: {
                              step_data: step,
                              isCompleted: _vm.isStepCompleted(step.index)
                            },
                            on: {
                              "step-clicked": function($event) {
                                return _vm.stepAction(index)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }